import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbComponent, BreadcrumbData, DropdownMenuComponent, FilterComponent } from '@mds/ui';
import { FormControl } from '@angular/forms';
import { AnalyzeBreadcrumbData } from '@mds/common';
import { FilterAndBreadcrumbEventName, FilterAndBreadcrumbEventsService, filterDataType } from '@services/filtersAndBreadcrumb.service';

@Component({
  selector: 'app-layers-header',
  standalone: true,
  imports: [
    CommonModule,
    BreadcrumbComponent,
    FilterComponent,
    DropdownMenuComponent,
  ],
  templateUrl: './layers-header.component.html',
  styleUrls: ['./layers-header.component.scss'],
})
export class LayersHeaderComponent {
  @Input() analyzeView: string;
  @Input() showSetDefaultView: boolean;
  @Input() groupLowImpactNodes: FormControl;
  @Input() showAllData: FormControl;
  @Input() breadcrumbData: BreadcrumbData<AnalyzeBreadcrumbData>[];
  @Input() showAllToggleFilter: boolean;
  @Input() tariffControl: FormControl;
  @Input() tariffForm: any;
  @Input() allTariffOptions: any[] = [];

  @Output() tariffToggle: EventEmitter<boolean> = new EventEmitter();
  @Output() selectedTariff: EventEmitter<[]> = new EventEmitter();
  @Output() searchTariff: EventEmitter<string> = new EventEmitter();
  @Output() showAllToggle: EventEmitter<boolean> = new EventEmitter();
  @Output() backToDefault: EventEmitter<void> = new EventEmitter();
  @Output() groupNodesToggle: EventEmitter<boolean> = new EventEmitter();
  @Output() onBreadcrumbSelect: EventEmitter<
    BreadcrumbData<AnalyzeBreadcrumbData>
  > = new EventEmitter();

  filterEvent = inject(FilterAndBreadcrumbEventsService);

  onShowAllToggle(event: boolean) {
    this.sendEventData(FilterAndBreadcrumbEventName.SHOW_ALL_DATA, event);
    this.showAllToggle.emit(event);
  }
  backToDefaultView() {
    this.sendEventData(FilterAndBreadcrumbEventName.BACK_TO_DEFAULT, null);
    this.backToDefault.emit();
  }
  onTariffToggle(event: boolean) {
    this.sendEventData(FilterAndBreadcrumbEventName.TARIFF_DATA, event);
    this.tariffToggle.emit(event);
  }

  onTariffSelection(event) {
    this.sendEventData(FilterAndBreadcrumbEventName.TARIFF_SELECTION, event);
    const data = { [this.tariffForm.key]: event };
    this.selectedTariff.emit(event);
  }

  searchValueChange(search: string) {
    this.searchTariff.emit(search);
  }

  onGroupSmallNodesToggle(event: boolean) {
    this.sendEventData(FilterAndBreadcrumbEventName.GROUP_NODES, event);
    this.groupNodesToggle.emit(event);
  }

  sendEventData(eventName: FilterAndBreadcrumbEventName, data: filterDataType) {
    this.filterEvent.emitFilterEvent({
      eventType: eventName,
      value: data,
    });
  }

  breadcrumbSelect(breadcrumbData: BreadcrumbData<AnalyzeBreadcrumbData>) {
    this.sendEventData(FilterAndBreadcrumbEventName.BREADCRUMB, breadcrumbData);
    this.onBreadcrumbSelect.emit(breadcrumbData);
  }
}
